import { useEffect, useState } from "react";
import { McpDefaultIcon } from "@/components/McpDefaultIcon";
import type { MCPConnection } from "../types";

type Props = {
  connection: Pick<
    MCPConnection,
    "name" | "icon" | "iconUrl" | "iconClassName"
  >;
  size?: "sm" | "md";
};

const SIZE_CLASS: Record<NonNullable<Props["size"]>, string> = {
  sm: "size-[42px] text-sm",
  md: "size-[42px] text-base",
};

const ConnectionIcon = ({ connection, size = "sm" }: Props) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [connection.iconUrl]);

  const showImage = Boolean(connection.iconUrl) && !imageFailed;
  const fallbackClass = connection.iconClassName ?? "bg-card text-foreground";

  return (
    <span
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-[6px] font-semibold ${SIZE_CLASS[size]} ${
        showImage ? "border border-border bg-white p-[9px]" : fallbackClass
      }`}
    >
      {showImage ? (
        <img
          src={connection.iconUrl ?? undefined}
          alt=""
          className="size-full object-contain"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <McpDefaultIcon className="size-6" />
      )}
    </span>
  );
};

export default ConnectionIcon;
